<mat-accordion>
  <mat-expansion-panel (opened)="isOpen.set(true)" (closed)="isOpen.set(false)">
    <mat-expansion-panel-header>
      <mat-panel-title class="accordion-title">{{titulo}} </mat-panel-title>
    </mat-expansion-panel-header>

    <hr />

    @for (item of lista; track $index; let last = $last) {
    <div [style.border-bottom]="!last ? '1px solid #8395a53d' : 'none'">
      <div class="pergunta-resposta-individual">
        <p class="pergunta">{{ item.title }}</p>
        <p class="resposta">{{ item.content }}</p>
      </div>
    </div>
    }
  </mat-expansion-panel>
</mat-accordion>
